import { getPageBrokerFlow } from './getPageBrokerFlow';
import { IAppState } from '../../common/state';

export const getPartnerRewardsLanding = (state: IAppState): string | null => {
  const pageFlowType = getPageBrokerFlow(state);
  const isPartnerRewardsRegistered = state.results?.newbuildingBroker?.isPartnerRewardsRegistered;

  if (pageFlowType === 'withPartnerRewards' && !isPartnerRewardsRegistered) {
    return state.results?.newbuildingBroker?.partnerRewardsFlowUrl || null;
  }

  return null;
};
